module.exports = __webpack_public_path__ + "static/media/gameBg.dfe0ba8e.svg";